import { Stack, Typography } from '@mui/material';
import { formatAbbreviatedPrice, getPercentage } from '../../helpers';

export const PercentageCellWithBackground = ({
  total,
  currentValue,
  backgroundColorFilled,
  backgroundColorEmpty,
  showTotal = false,
}: {
  total: number | null;
  currentValue: number | null;
  backgroundColorFilled: string;
  backgroundColorEmpty: string;
  showTotal?: boolean;
}) => {
  if (typeof total !== 'number') {
    return 'No Goals Set';
  }

  const percentage = getPercentage(currentValue, total);

  return (
    <Stack
      sx={{
        height: '100%',
        justifyContent: 'center',
      }}
    >
      <Stack
        sx={{
          backgroundColor: backgroundColorEmpty,
          height: '40px',
          overflow: 'hidden',
        }}
      >
        <Stack
          sx={{
            backgroundColor: backgroundColorFilled,
            height: '100%',
            width: `${percentage}%`,
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="h5"
            component="span"
            sx={{ color: 'text.primary', px: 1 }}
          >
            {percentage}%
            {showTotal
              ? ` of ${formatAbbreviatedPrice(total, { trimTrailingZeros: true })}`
              : ''}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
